import './styles.scss'
import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import ClickOutHandler from 'react-onclickout'

import { translations } from 'api'
import i18nActions from 'redux/actions/i18nActions'
import Nixi1Spinner from 'components/Nixi1Spinner'

const ALLOW_EDIT = ['admin', 'owner']

const EditableLabel = ({ tag, loggedUser }) => {
  const [isReadOnly, setIsReadOnly] = useState(true)
  const [text, setText] = useState(I18n.t(tag))
  const [removing, setRemoving] = useState(false)
  const dispatch = useDispatch()

  const isAllowEdit = ALLOW_EDIT.includes(loggedUser.role)

  const handleTranslation = () => {
    setIsReadOnly(!isReadOnly)

    if (!isReadOnly && text !== I18n.t(tag)) {
      translations.setTranslation({
        tag,
        text,
        locale: loggedUser.locale
      })
        .then(() => {
          i18nActions.updateText({
            locale: loggedUser.locale,
            company: loggedUser.company,
            type: loggedUser.companyType,
          })(dispatch)
        })
    }
  }

  const removeTranslation = () => {
    setRemoving(true)

    translations.removeTranslation({ tag })
      .then(async () => {
        await i18nActions.updateText({
          locale: loggedUser.locale,
          company: loggedUser.company,
          type: loggedUser.companyType,
        })(dispatch)

        setText(I18n.t(tag))
        setRemoving(false)
      })
      .catch(data => {
        setRemoving(false)
      })
  }

  const onResetValue = useCallback(() => {
    if (!isReadOnly) {
      setIsReadOnly(true)
      setText(I18n.t(tag))
    }
  }, [isReadOnly, tag])

  return (
    <ClickOutHandler onClickOut={onResetValue}>
      <div className={`editable-label ${isReadOnly ? 'editable-label--hover' : ''}`}>
        {
          isReadOnly ? (
            <label className='text-ellipsis'>{text}</label>
          ) : (
            <div className='editable-label__input-container'>
              <input
                type='text'
                value={text}
                onChange={event => setText(event.target.value)}
              />
            </div>
          )
        }
        {
          isAllowEdit && (
            removing ? (
              <div
                className='editable-label__spinner-wrapper'
                style={{
                  marginRight: isReadOnly ? '10px' : '22.5px',
                  paddingLeft: isReadOnly ? '5px' : '0',
                  backgroundColor: isReadOnly ? 'white' : 'transparent'
                }}
              >
                <Nixi1Spinner width='20px' height='20px' />
              </div>
            ) : (
              <div
                className='editable-label__buttons'
                style={{
                  marginRight: isReadOnly ? '10px' : '22.5px',
                  paddingLeft: isReadOnly ? '5px' : '0',
                  backgroundColor: isReadOnly ? 'white' : 'transparent',
                  visibility: !isReadOnly ? 'visible' : null
                }}
              >
                {
                  isReadOnly && (
                    <i
                      className='fa fa-times'
                      onClick={removeTranslation}
                    ></i>
                  )
                }
                <i
                  className={`fa ${isReadOnly ? 'fa-pencil' : 'fa-floppy-o'}`}
                  onClick={handleTranslation}
                ></i>
              </div>
            )
          )
        }
      </div>
    </ClickOutHandler>
  )
}

export { EditableLabel }
